import React, { useState } from 'react';
//import { Input } from 'formsy-react-components';
import { useTranslation } from 'react-i18next';
import { getObjectValue, setNestedValue } from '../../helpers/general';
import validator from "validator";

const PrizeGameParticipation = ({ index, prizeGame, sourceId, onChange, validate }) => {
  const { t, i18n } = useTranslation();
  const [prizeGameVisible, setPrizeGameVisible] = useState(false);

  const [data, setData] = useState({email: "", termsAndConditions: false, gdprPromotionsChecked: false, showPrizeGame: false});

  let lng = i18n.language.toUpperCase();
  let participationConfirmationText = t("review.prize.ph1");
  let emailLabel = t("review.prize.pe");
  let emailPlaceHolder = "";
  let participationClassName = "reviewInvite-prizeGameShow";

  if (prizeGame.type === "COUPON") {
    participationConfirmationText = t("review.prize.ch1");
    emailLabel = t("review.prize.ce");
    emailPlaceHolder = t("review.prize.ye");
    participationClassName = "reviewInvite-couponShow";
  }

  const handlePrizeGame = (e) => {
    setPrizeGameVisible(!prizeGameVisible);
    const temp = {...data};
    setNestedValue(temp, "showPrizeGame", !prizeGameVisible);
    setData(temp);
    onChange?.(index, temp);
  };

  const handleEmailChange = (e) => {
    const temp = {...data};
    setNestedValue(temp, "email", e.target.value);
    setData(temp);
    onChange?.(index, temp);
  };

  const handleTermsChange = (e) => {
    const temp = {...data};
    setNestedValue(temp, "termsAndConditions", e.target.checked);
    setData(temp);
    onChange?.(index, temp);
  };

  const handleGdprPromotionsChange = (e) => {
    const temp = {...data};
    setNestedValue(temp, "gdprPromotionsChecked", e.target.checked);
    setData(temp);
    onChange?.(index, temp);
  };

  const makeAbsoluteURL = (url) => {
    if (validator.isURL(url, { require_protocol: true })) {
      return url;
    }
    return 'https://'+url;
  };

  //return <pre>{JSON.stringify(props.prizeGame, null, 2)}</pre>;
  return (
    <div className="prizeGameShowWrap margin-bottom-20 clearfix">
      {prizeGameVisible ? (
        <div className={"reviewInvite-question " + participationClassName}>
          <div className="reviewInvite-prizeGame clearfix">
            <div className="col-md-8 col-md-offset-2 reviewInvite-prizeGameQuestion mx-auto">
              <h2 className="prizeGame-title text-center">{prizeGame.title[lng]}</h2>
              <p className="description text-center">{prizeGame.description[lng]}</p>
              <p className="labelCustom px-0">{emailLabel}</p>
              <input
                className='w-100'
                type="text"
                name="email"
                value={getObjectValue(data, "email")}
                placeholder={emailPlaceHolder}
                //validationError={t("review.prize.ve")}
                onChange={handleEmailChange}
              />
              
              {(validate[index+".email"] === false) &&
                <p className="textareaRequired">{t("review.prize.ve")}</p>
              }
              <div className="checkbox-wrap p-0 ">
                <input
                  className='my-1'
                  type="checkbox"
                  id={sourceId + "terms"}
                  name="termsDescription"
                  onChange={handleTermsChange}
                />
                <label htmlFor={sourceId + "terms"}>{prizeGame.terms_and_conditions_description[lng]}</label>

                {!data.termsAndConditions && validate[index+".termsAndConditions"] === false &&
                  <div className="checkbox-wrap-error">
                    <p>
                        {t("review.prize.term")}
                    </p>
                  </div>
                }
              </div>

              {prizeGame.gdpr_promotions.enabled && prizeGame.gdpr_promotions.checkboxTexts[lng] && (
                <div className="checkbox-wrap">
                  <input
                    type="checkbox"
                    id={sourceId + "gdprPromotions"}
                    name="gdprPromotionsCheckbox"
                    onChange={handleGdprPromotionsChange}
                  />
                  <label htmlFor={sourceId + "gdprPromotions"}>{prizeGame.gdpr_promotions.checkboxTexts[lng]}</label>
                </div>
              )}

              {prizeGame.terms_and_conditions && (
                <p className="reviewInvite-prizeGameTerms">
                  {t("review.prize.te1")}&nbsp;
                  <a href={makeAbsoluteURL(prizeGame.terms_and_conditions)} target="_blank" rel="noreferrer" >
                    {t("review.prize.te2")}
                  </a>
                  .
                </p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>
          <a onClick={handlePrizeGame} className={participationClassName} >
            <h3>
              <span className="checkbox"></span>
              {participationConfirmationText}
            </h3>
          </a>
        </div>
      )}
    </div>
  );
};

export default PrizeGameParticipation;
